import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { CALL_TO_ACTION_LINKS } from 'src/services/mappings/callToAction/callToAction.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const callToActionFields: FieldInterface[] = [
  {
    key: 'name',
    originKey: 'name',
    type: FIELD_TYPES.string,
  },
  {
    key: 'message',
    originKey: 'message',
    type: FIELD_TYPES.string,
  },
  {
    key: 'link',
    originKey: 'link',
    type: FIELD_TYPES.string,
    enumKeys: [
      CALL_TO_ACTION_LINKS.fastCircuit,
      CALL_TO_ACTION_LINKS.inheritance,
      CALL_TO_ACTION_LINKS.patrimonialGrowth,
    ],
  },
  {
    key: 'priority',
    originKey: 'priority',
    type: FIELD_TYPES.integer,
  },
]

const callToActionRelations: RelationInterface[] = []

export { callToActionFields, callToActionRelations }
